module.exports = __webpack_public_path__ + "static/hero_bg-1c637441fb74f085456e18acc1bb9331.jpg";